import React, { useMemo } from "react";
import { Search } from "lucide-react";

import {
  masterBarWrapper,
  masterSearchBoxWrap,
  masterSearchInput,
  masterSearchIcon,
  masterPaginationWrap,
  masterPagLabel,
  masterPagSelect,
  masterPagCountText,
  masterPagBtn,
} from "./MasterCssClass"; // Adjust relative path as needed

const PaginationSearchbar = ({
  searchTerm = "",
  onSearchChange,
  searchPlaceholder = "SEARCH BY DOCTOR NAME...",
  currentPage = 1,
  onPageChange,
  rowsPerPage = 10,
  onRowsPerPageChange,
  totalItems = 0,
}) => {
  const isAll = rowsPerPage === "ALL" || rowsPerPage === totalItems;

  // Compute total pages (if "ALL", there's only 1 page)
  const totalPages = isAll ? 1 : Math.max(1, Math.ceil(totalItems / rowsPerPage));

  // Compute displayed item range (e.g., "1-10 OF 46" or "1-46 OF 46")
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * (isAll ? totalItems : rowsPerPage) + 1;
  const endItem = isAll ? totalItems : Math.min(currentPage * rowsPerPage, totalItems);

  // Generate page numbers for dropdown
  const pageNumbers = useMemo(() => {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }, [totalPages]);

  return (
    <div className={masterBarWrapper}>
      {/* LEFT: SEARCH BAR WITH GREEN BORDER FOCUS */}
      <div className={masterSearchBoxWrap}>
        <Search size={14} className={masterSearchIcon} />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => {
            // Automatically converts typing to UPPERCASE
            const upperValue = e.target.value.toUpperCase();
            onSearchChange(upperValue);
            onPageChange(1); // Reset to page 1 on search
          }}
          className={`${masterSearchInput} uppercase`}
        />
      </div>

      {/* RIGHT: PAGINATION CONTROLS */}
      <div className={masterPaginationWrap}>
        {/* ROWS PER PAGE DROPDOWN */}
        <span className={masterPagLabel}>ROWS</span>
        <select
          value={rowsPerPage}
          onChange={(e) => {
            const val = e.target.value;
            onRowsPerPageChange(val === "ALL" ? "ALL" : Number(val));
            onPageChange(1);
          }}
          className={masterPagSelect}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value="ALL">ALL</option>
        </select>

        {/* DISPLAY RANGE COUNTER */}
        <span className={masterPagCountText}>
          {startItem}-{endItem} OF {totalItems}
        </span>

        {/* PREVIOUS BUTTON */}
        <button
          type="button"
          disabled={isAll || currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          className={masterPagBtn}
        >
          Prev
        </button>

        {/* PAGE DROPDOWN */}
        <span className={masterPagLabel}>PAGE</span>
        <select
          value={currentPage}
          disabled={isAll}
          onChange={(e) => onPageChange(Number(e.target.value))}
          className={masterPagSelect}
        >
          {pageNumbers.map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>

        {/* TOTAL PAGES LABEL */}
        <span className={masterPagLabel}>OF {totalPages}</span>

        {/* NEXT BUTTON */}
        <button
          type="button"
          disabled={isAll || currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className={masterPagBtn}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationSearchbar;